var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "app-icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2115 16.0973L25.9087 8.34082H24.3217L18.5065 15.0756L13.8619 8.34082H8.50488L15.5284 18.5251L8.50488 26.6589H10.092L16.233 19.5467L21.1381 26.6589H26.4951L19.2115 16.0973ZM17.0377 18.6148L16.3261 17.6007L10.6639 9.5312H13.1016L17.6711 16.0435L18.3827 17.0576L24.3224 25.5227H21.8847L17.0377 18.6148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterX);
export default __webpack_public_path__ + "static/media/footer_X.2e71f44702880450704df364cd315f35.svg";
export { ForwardRef as ReactComponent };